import AnimatedPage from './AnimatedPage';

/*
    Animation des pages Agence.
*/
class Error404 extends AnimatedPage{
    constructor(){
        $(window).scroll(0,0);
        super(200);


        this.showPage();
        this._initScroll();

    }

    showPage(){
        let $h1 = $('.Cover h1'),
            $accroche = $('.Cover-accroche'),
            $coverImg = $('.Cover-img'),
            $firstVisuel = $('.Slice-firstVisuel')
        ;

        let tl = new TimelineLite()
        // .fromTo($coverImg,1,{scale:1,autoAlpha:0},{scale:1.3,autoAlpha:1,ease:Power4.easeOut})
        .fromTo($h1, 0.7, {y:60, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power4.easeInOut},0)
        .fromTo($accroche,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},.5)
        .add(this.showHeader(),.5)
        // .fromTo($firstVisuel,1,{y:30,autoAlpha:0},{y:0,autoAlpha:1,ease:Power4.easeOut},.6)
    }
}
export default Error404;
